import { DispachedServicePart } from '@services';

// action strings
export const ADD_SERVICE_PART = 'ADD_SERVICE_PART';
export const ADD_SERVICE_PART_FROM_INVENTORY = 'ADD_SERVICE_PART_FROM_INVENTORY';
export const ADD_SERVICE_PARTS = 'ADD_SERVICE_PARTS';
export const REMOVE_SERVICE_PART = 'REMOVE_SERVICE_PART';
export const REMOVE_SERVICE_PARTS = 'REMOVE_SERVICE_PARTS';
export const CHANGE_SERVICE_PART = 'CHANGE_SERVICE_PART';
export const RESET_SERVICE_PARTS = 'RESET_SERVICE_PARTS';

export interface AddServicePart {
  type: typeof ADD_SERVICE_PART;
  serviceId?: number;
}

export interface AddServicePartFromInventory {
  type: typeof ADD_SERVICE_PART_FROM_INVENTORY;
  serviceId: number;
  servicePart: DispachedServicePart;
}

export interface AddServiceParts {
  type: typeof ADD_SERVICE_PARTS;
  serviceId: number;
  serviceParts: DispachedServicePart[];
}

export interface RemoveServicePart {
  type: typeof REMOVE_SERVICE_PART;
  serviceId?: number;
  index: number;
}

export interface RemoveServiceParts {
  type: typeof REMOVE_SERVICE_PARTS;
  serviceId?: number;
}

export interface ChangeServicePart {
  type: typeof CHANGE_SERVICE_PART;
  servicePart: DispachedServicePart;
  serviceId?: number;
  index: number;
}

export interface ResetServicePart {
  type: typeof RESET_SERVICE_PARTS;
}

export type ServicePartActions =
  | AddServicePart
  | AddServicePartFromInventory
  | AddServiceParts
  | RemoveServicePart
  | RemoveServiceParts
  | ChangeServicePart
  | ResetServicePart;
